<div class="company-type" data-qa="role-selection">
  <div class="grid" data-qa="role-title-grid">
    <div class="col-12" data-qa="role-title-col">
      <div class="registration-title">What's your role?</div>
    </div>
  </div>
  <div class="row registration-sub-title company-type-sub-title" data-qa="role-subtitle-row">
    <div class="col-12" data-qa="role-subtitle-col">
      Please check all that apply to help us customize your onboarding
      experience
    </div>
  </div>
  <div class="type-container" data-qa="role-options">
    @for (role of rolesArray(); track role.userRoleId) {
      <div
        class="type-item"
        [ngClass]="{ 'type-selected': isRoleSelected(role.userRoleId) }"
        (click)="onCompanyBuyerChanged($event, role.userRoleId)"
        data-qa="role-option"
      >
        <div class="type-item-body" data-qa="role-content">
          <div class="type-item-title" data-qa="role-title">
            {{ role.name }}
            <div class="type-item-check" data-qa="role-checkbox">
              <p-checkbox
                [ngModel]="isRoleSelected(role.userRoleId)"
                [binary]="true"
                [readonly]="true"
                #checkbox
              ></p-checkbox>
            </div>
          </div>
          <div class="type-item-subtitle" data-qa="role-description">{{ role.description }}</div>
        </div>
      </div>
    }
  </div>
</div>
